// extracted by mini-css-extract-plugin
module.exports = {"badge":"InternalCamBadge_badge__ml2iu"};